export default "__VITE_ASSET__DPS9I3zV__"